import { FunTransactionLogType } from '../../shared/models/api/fun-transaction-log.model';

export const transactionLogTypeTranslation: Readonly<Record<FunTransactionLogType, string>> = {
  [FunTransactionLogType.ALLOWANCE]: 'FUN_BUDGET.TRANSACTION_LOG.TYPE.ALLOWANCE',
  [FunTransactionLogType.COST]: 'FUN_BUDGET.TRANSACTION_LOG.TYPE.COST',
  [FunTransactionLogType.REMAINING]: 'FUN_BUDGET.TRANSACTION_LOG.TYPE.REMAINING',
  [FunTransactionLogType.AVAILABLE]: 'FUN_BUDGET.TRANSACTION_LOG.TYPE.AVAILABLE',
  [FunTransactionLogType.CORRECTION]: 'FUN_BUDGET.TRANSACTION_LOG.TYPE.CORRECTION',
};
